import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { LabOrder } from '../../shared/data/lab-order';
import { ReferenceListItem } from '../../shared/data/reference-list-item';
import { LabOrderBusinessService } from '../../shared/lab-order-business.service';
import { REF_LIST } from '../../shared/lab-order-reference-api.service';
import {SubscriptionsContainer} from '../../shared/subscriptions-container';


@Component({
  selector: 'app-special-instructions',
  templateUrl: './special-instructions.component.html',
  styleUrls: ['./special-instructions.component.css']
})
export class SpecialInstructionsComponent implements OnInit, OnDestroy {

  @Input() labOrder: LabOrder;
  checkBoxValue: boolean;
  specialInstructionTypes: ReferenceListItem[];
  subs = new SubscriptionsContainer();

  constructor(private labOrderBusinessService: LabOrderBusinessService) { }

  ngOnInit(): void {

    this.subs.add = this.labOrderBusinessService.getReferenceListsByNames([REF_LIST.SPECIAL_INSTRUCTIONS])
      .subscribe(
        (data) => {
          this.specialInstructionTypes = data[0];
          if (this.labOrder.labSpecialInstructionType) {
            this.checkBoxValue = true;
          }
          this.checkBoxChange();
        },
        (error) => {
          this.specialInstructionTypes = null;
          console.log('Did not retrieve special instructions drop down list from referencelists');
        }
      );
  }

  ngOnDestroy(): void {
    console.log(' Special Instructions Component - ngOnDestroy ' );
    this.subs.dispose();
  }


  checkBoxChange() {
    if (!this.checkBoxValue) { // if checkbox unchecked, aka value false
      // Reset these values, to avoid extraneous field values being saved to DB
      if (this.labOrder && this.labOrder.labSpecialInstructionType) {
        this.labOrder.labSpecialInstructionType = '';
      }

      if (this.labOrder && this.labOrder.redoOrderNumber) {
        this.labOrder.redoOrderNumber = '';
      }

      if (this.labOrder && this.labOrder.labSpecialInstruction) {
        this.labOrder.labSpecialInstruction = '';
      }
    }
  }

  clearInputs() {
    delete this.labOrder.redoOrderNumber;
    delete this.labOrder.labSpecialInstruction;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/modify-order/special-instructions/special-instructions.component.ts